<template>
    <v-dialog
            scrollable
            v-model="visible"
            max-width="900px"
            :fullscreen="fullscreen"
            :persistent="true"
    >
        <v-card>
            <v-toolbar flat dense>
                <v-toolbar-title class="subheading">{{ title }}（项目申请）</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="fullscreen=!fullscreen">
                    <v-icon>fullscreen</v-icon>
                </v-btn>
            </v-toolbar>

            <v-divider style="max-height: 1px"/>
            <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

            <v-card-text>
                <v-form v-model="formValid" ref="formRef" lazy-validation>
                    <v-container grid-list-md>
                        <v-layout wrap>

                            <v-flex xs12 sm12>
                                <v-text-field
                                        label="项目名称"
                                        required
                                        ref="inputProjName"
                                        :rules="rules.required"
                                        v-model="item.name"/>
                            </v-flex>

                            <v-flex xs12 sm6>
                                <v-autocomplete
                                        item-text="name"
                                        item-value="dbid"
                                        :items="typeItems"
                                        :loading="typeLoading"
                                        v-model="item.typeId"
                                        label="项目类别"
                                        required
                                        :rules="rules.required"
                                        hide-details
                                        clearable
                                >
                                    <template slot="item" slot-scope="data">
                                        <v-subheader v-if="!data.item.leaf" :class="`pl-${data.item.level * 4}`">
                                            <v-icon>more_horiz</v-icon>
                                            {{data.item.name}}
                                        </v-subheader>
                                        <v-list-tile-content v-else :class="`pl-${data.item.level * 4}`">
                                            {{data.item.name}}
                                        </v-list-tile-content>
                                    </template>
                                </v-autocomplete>
                            </v-flex>

                            <v-flex xs12 sm6>
                                <v-text-field
                                        label="委托单位"
                                        required
                                        :rules="rules.required"
                                        v-model="item.client"/>
                            </v-flex>

                            <v-flex xs12 sm4>
                                <v-select
                                        label="校内主管部门"
                                        clearable
                                        required
                                        :rules="rules.required"
                                        v-model="item.adminDeptId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="adminDeptItems"
                                />
                            </v-flex>

                            <v-flex xs12 sm4>
                                <v-text-field
                                        label="合同金额"
                                        required
                                        :rules="rules.amount"
                                        v-model="item.contractAmounts"
                                        prefix="¥"
                                        suffix="元"
                                        hint="填写数字, 最多保留两位小数。"
                                        persistent-hint
                                />
                            </v-flex>

                          <v-flex xs12 sm2>
                            <v-autocomplete
                                label="是否统计经费"
                                required
                                :rules="rules.required"
                                v-model="item.countFund"
                                :items=countFundItems
                            />
                          </v-flex>

                            <v-flex xs12 sm2>
                                <v-autocomplete
                                        label="项目性质"
                                        required
                                        :rules="rules.required"
                                        v-model="item.property"
                                        :items="propertyItems"
                                />
                            </v-flex>

                            <v-flex xs12 sm6>
                                <x-user-select-form
                                        label="项目负责人"
                                        :rules="rules.required"
                                        v-model="leader"
                                        @update-info="handleUpdate"
                                        hint="输入关键词，检索添加本单位项目负责人；或直接录入外单位项目负责人。"
                                        persistent-hint
                                />
                            </v-flex>

                            <v-flex xs12 sm3>
                                <v-text-field
                                        label="负责人电话"
                                        v-model="item.leaderPhone"
                                />
                            </v-flex>

                            <v-flex xs12 sm3>
                                <v-text-field
                                        label="负责人邮箱"
                                        v-model="item.leaderEmail"
                                        :rules="rules.email"
                                />
                            </v-flex>

                            <v-flex xs12 sm6>
                                <v-autocomplete
                                        label="承担部门"
                                        clearable
                                        required
                                        :rules="rules.required"
                                        v-model="item.deptId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="deptItems"
                                        :loading="deptLoading"
                                />
                            </v-flex>


                            <v-flex xs12 sm3>
                                <v-menu
                                        ref="startDatePickerRef"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="startDateMenu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            label="开始日期"
                                            v-model="item.startDate"
                                            :rules="rules.startDate"
                                            hint="格式YYYY-MM-DD, 如：2018-10-01"
                                            persistent-hint
                                    />

                                    <v-date-picker
                                            v-model="startDate"
                                            locale="zh-cn"
                                            @change="nv => item.startDate= nv"
                                    />
                                </v-menu>
                            </v-flex>

                            <v-flex xs12 sm3>
                                <v-menu
                                        ref="finishDatePickerRef"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="finishDateMenu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            label="结束日期"
                                            required
                                            v-model="item.finishDate"
                                            :rules="rules.finishDate"
                                            hint="格式YYYY-MM-DD, 如：2018-10-01"
                                            persistent-hint
                                    />

                                    <v-date-picker
                                            v-model="finishDate"
                                            locale="zh-cn"
                                            @change="nv => item.finishDate= nv"
                                    />
                                </v-menu>
                            </v-flex>

                            <v-flex xs6>
                                <v-autocomplete
                                        label="学科分类"
                                        clearable
                                        required
                                        :rules="rules.required"
                                        v-model="item.subjectId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="subjectItems"
                                        :loading="subjectLoading"
                                />
                            </v-flex>

                            <v-flex xs6>
                                <v-autocomplete
                                        label="研究活动类别"
                                        clearable
                                        required
                                        :rules="rules.required"
                                        v-model="item.researchTypeId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="researchTypeItems"
                                        :loading="researchTypeLoading"
                                />
                            </v-flex>

                            <v-flex xs12 sm6>
                                <v-autocomplete
                                        label="组织形式"
                                        clearable
                                        :rules="rules.required"
                                        v-model="item.organizeForm"
                                        :items="organizeFormItems"
                                        @change="(v)=> { if(v !== '合作单位') item.coopeFormId = null }"
                                />
                            </v-flex>

                            <v-flex xs12 sm6>
                                <v-autocomplete
                                        label="合作形式"
                                        v-model="item.coopeFormId"
                                        :disabled="item.organizeForm !== '合作单位'"
                                        :items="coopeFormItems"
                                        item-text="name"
                                        item-value="dbid"
                                        :loading="coopeFormLoading"
                                />
                            </v-flex>

                            <v-flex xs12 sm6>
                                <v-autocomplete
                                        item-text="name"
                                        item-value="dbid"
                                        :items="indstTypeItems"
                                        :loading="indstTypeLoading"
                                        v-model="item.industryTypeId"
                                        label="服务的国民经济行业"
                                        hide-details
                                        clearable
                                        :menu-props="{maxHeight:400}"
                                >
                                    <template slot="item" slot-scope="data">
                                        <template v-if="typeof data.item !== 'object'">
                                            <v-list-tile-content v-text="data.item.name"/>
                                        </template>
                                        <template v-else>
                                            <v-list-tile-content>
                                                <v-list-tile-title class="pl-3" v-html="data.item.name"/>
                                            </v-list-tile-content>
                                        </template>
                                    </template>
                                </v-autocomplete>
                            </v-flex>

                            <v-flex xs12 sm6>
                                <v-autocomplete
                                        label="社会经济目标"
                                        clearable
                                        v-model="item.objectiveTypeId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="objecTypeItems"
                                        :loading="objecTypeLoading"
                                />
                            </v-flex>

                            <v-flex xs12>
                                <x-uploader
                                        label="附件列表"
                                        :action="fileUri"
                                        v-model="item.attachments"
                                        :size="Number(50)"
                                        :description="[
                    '申请书、证明材料等。',
                    '建议提交 PDF 格式文件',
                    '单个附件大小不超过 50M.'
                  ]"
                                />
                            </v-flex>

                          <v-flex xs12 sm1>
                            <v-autocomplete
                                v-if="false"
                                label="绩效发放部门"
                                clearable
                                required
                                :disabled="scoreDeptDisnable"
                                :rules="rules.required"
                                v-model="item.scoreDeptId"
                                item-text="name"
                                item-value="dbid"
                                :items="deptItems"
                                :loading="deptLoading"
                            />
                          </v-flex>

                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
                <v-btn color="primary" @click.native="onCheck">保存
                </v-btn>
            </v-card-actions>
        </v-card>

      <v-dialog v-model="showAlert" max-width="700px" persistent>
        <v-card class="modern-card">
          <div class="modern-header">
            <v-icon color="white" large>mdi-file-document-alert</v-icon>
            <h2 class="modern-title">项目重复登记提醒</h2>
          </div>

          <v-card-text class="modern-content">
            <div class="modern-message">
              <p class="modern-text">您尝试登记的项目：</p>
              <div class="modern-highlight">
                <p class="modern-paper-title">{{ projType }} '{{ projName }}'</p>
              </div>

              <v-divider class="my-4"/>

              <p class="modern-text">已被负责人：</p>
              <div class="modern-highlight">
                <p class="modern-paper-title">{{ leaderDept }}的{{ projLeader }}教师登记</p>
              </div>
              <div class="modern-alert mt-4">
                <v-icon color="error" small>mdi-alert-circle</v-icon>
                <span>系统不允许项目重复登记,请联系登记该项目的老师或科技处相关人员处理。</span>
              </div>

            </div>
          </v-card-text>

          <v-card-actions class="modern-actions">
            <v-spacer/>
            <v-btn
                color="#4a6baf"
                dark
                depressed
                @click="showAlert = false; projHave = true"
                class="modern-btn"
            >
              确认
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
</template>
<script>

    import mixin from '@/mixin'

    import XUserSelectForm from '@/components/global/UserSelectForm'
    import XUploader from '@/components/global/Uploader'
    import axios from "axios";
    import {mapGetters} from "vuex";

    const baseUri = '/api/proj/project/appl';
    const checkProjHaveUri = '/api/proj/project/check/proj/have';

    export default {
        mixins: [mixin.edit(baseUri)],

        components: {XUserSelectForm, XUploader},
        data() {
            return {
                formValid: false,

                fileUri: '/api/proj/attachment',


                item: {},
                freshItem: {
                    "name": null,
                    "number": null,
                    "leadingUnit": null,
                    "typeId": null,
                    "client": null,
                    "deptId": null,
                    "leaderId": null,
                    "leaderName": null,
                    "leaderPhone": null,
                    "leaderEmail": null,
                    "contractAmounts": null,
                    "startDate": null,
                    "finishDate": null,
                    "subjectId": null,
                    "researchTypeId": null,
                    "organizeForm": null,
                    "coopeFormId": null,
                    "industryTypeId": null,
                    "objectiveTypeId": null,
                    "statusId": null,
                    "reviewStatus": null,
                    "entryDate": null,
                    "code": null,
                    "adminDeptId": null,
                    "level": null,
                    "bugetSource": null,
                    "turnover": null,
                    "completedDate": null,
                    "property": null
                },

                startDateMenu: false,
                startDate: null,

                finishDateMenu: false,
                finishDate: null,

                showAlert: false,
                leaderDept: '',
                projLeader: '',
                projName: '',
                projHave: false,
                projType: '',

                leader: {},

                scoreDeptDisnable : false,

                statusItems: [],
                typeItems: [],
                deptItems: [],
                adminDeptItems: [],
                leaderItems: [],
                subjectItems: [],
                researchTypeItems: [],
                indstTypeItems: [],
                objecTypeItems: [],
                coopeFormItems: [],

                devProjTypeIds: [],

                organizeFormItems: ['牵头单位', '合作单位'],
                propertyItems: [{value: 'zk', text: '自科'}, {value: 'sk', text: '社科'}],
                countFundItems:[{value: 'T', text: '统计'},{value: 'F', text: '不统计'}],

                statusLoading: false,
                typeLoading: false,
                deptLoading: false,
                leaderLoading: false,
                subjectLoading: false,
                researchTypeLoading: false,
                indstTypeLoading: false,
                objecTypeLoading: false,
                coopeFormLoading: false,

                leaderSearch: '',
                indstClsSearch: '',

                dialogAfterSave: false,

                /**
                 * 验证规则
                 */
                rules: {
                    required: [
                        v => !!v || '必填项。'
                    ],
                    normal: [v => (!v || v.length <= 50) || '长度必须小于50个字符。'],
                    amount: [
                        v => !!v || '必填项。',
                        v => (v && /^\d{1,10}?(.[0-9][0-9]?)?$/ig.test(v)) || '填写数字，小数点后最多保留2位。'
                    ],
                    email: [
                        v => (!v || /^[\w.-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/ig.test(v)) || '邮箱格式不正确。'
                    ],

                    turnover: [
                        v => (!this.devProjTypeIds.includes(this.item.typeId) || (v && /^\d{1,10}?(.[0-9][0-9]?)?$/ig.test(v))) || '填写数字，小数点后最多保留2位。'
                    ],
                    startDate: [
                        v => !!v || "必填项。",
                        v => window.xutil.regexpDate().test(v) || '日期格式错误'
                    ],
                    finishDate: [
                        v => !!v || "必填项。",
                        v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
                        v => (v && v > this.item.startDate) || "截止日期必须晚于起始日期。"
                    ]
                },

                sectionLoading: false,
                sectionItems: [],
                sectionSearch: ''
            }
        },

        created() {
            const params = {"sort": "rank.asc", "limit": 255};

            const statusUri = '/api/proj/proj-status';
            const typeUri = '/api/proj/project-type/flatten/tree';
            const researchTypeUri = '/api/proj/research-type';
            const objecTypeUri = '/api/proj/objective-type';
            const indstTypeUri = '/api/proj/industry-type/flatten/tree';
            const coopeFormUri = '/api/proj/coope-form';

            const deptUri = '/api/syst/department';
            const subjectUri = '/api/code/subject';

            const contractId = this.$route.query.contractId;
            const ctraUri = `/api/ctra/contract/${contractId}`;

            // 初始化时设置
            if (this.userId) {
              this.leader = { userId: this.userId }
            }

            this.loading = true;

            [
                this.statusLoading, this.typeLoading, this.researchTypeLoading,
                this.objecTypeLoading, this.deptLoading, this.subjectLoading, this.indstTypeLoading, this.coopeFormLoading
            ].forEach(
                // eslint-disable-next-line
                v => v = true
            );

            this.axios.all([
                this.axios.get(statusUri, {params}),
                this.axios.get(typeUri, {params}),
                this.axios.get(researchTypeUri, {params}),
                this.axios.get(objecTypeUri, {params}),
                this.axios.get(deptUri, {params}),
                this.axios.get(subjectUri, {params}),
                this.axios.get(indstTypeUri),
                this.axios.get(coopeFormUri, {params})
            ]).then(
                this.axios.spread(
                    (rspStat, rspType, rspResearchType, rspObjecCls, rspDept, rspSubject, rspIndst, rspCoope) => {
                        this.statusLoading = false;
                        this.statusItems = rspStat.data.items;

                        this.typeLoading = false;
                        this.typeItems = rspType.data.reduce(
                            (acc, v, i) => {
                                if (!v.leaf) {
                                    if (i > 0)
                                        acc.push({divider: true}, {header: v.name});
                                    else
                                        acc.push({header: v.name});
                                } else {
                                    acc.push(v);
                                }
                                return acc;
                            }, []);

                        // 横向合同项目类型
                        this.devProjTypeIds = this.typeItems.filter(v => v.parentId === 'Db2NlYTLADg').map(v => v.dbid);

                        this.researchTypeLoading = false;
                        this.researchTypeItems = rspResearchType.data.items;

                        this.objecTypeLoading = false;
                        this.objecTypeItems = rspObjecCls.data.items;

                        this.deptLoading = false;
                        this.deptItems = rspDept.data.items;
                        window.console.log(this.deptItems)
                        // 科研主管部门
                        this.adminDeptItems = rspDept.data.items.filter(v => v.isAdmin).reverse();

                        this.subjectLoading = false;
                        this.subjectItems = rspSubject.data.items;

                        this.indstTypeLoading = false;
                        this.indstTypeItems = rspIndst.data.reduce(
                            (acc, v, i) => {
                                if (!v.leaf) {
                                    if (i > 0)
                                        acc.push({divider: true}, {header: v.name});
                                    else
                                        acc.push({header: v.name});
                                } else {
                                    acc.push(v);
                                }
                                return acc;
                            }, []);

                        this.coopeFormLoading = false;
                        this.coopeFormItems = rspCoope.data.items;

                        if (contractId) {
                            this.axios.get(ctraUri).then(rsp => {
                                const fields = [
                                    "name",
                                    "adminDeptId",
                                    // "deptId",
                                    // "leaderId",
                                    // "leaderName",
                                    "statusId",
                                    "typeId",
                                    //"property",
                                    "client",
                                    //"clientTypeId",
                                    //"amount",
                                    //"bidding",
                                    //"applDate",
                                    // "leaderPhone",
                                    // "leaderEmail",
                                    "startDate",
                                    "finishDate",
                                    "turnover",
                                    "industryClassId"];

                                fields.forEach(f => this.item[f] = rsp.data[f]);

                                this.item.contractAmounts = rsp.data.amount;

                                this.item.leader = {
                                    userId: rsp.data.leaderId,
                                    name: rsp.data.leaderName,
                                    deptId: rsp.data.deptId,
                                    phone: rsp.data.leaderPhone,
                                    email: rsp.data.leaderEmail,
                                }
                            });
                        }

                        this.loading = false;

                    }
                )
            );
        },

      computed: {
        ...mapGetters(['funcIds','userId'])
      },

      watch: {
            "leader": function (v) {
                if (v) {
                    this.item.leaderId = v.userId;
                    this.item.leaderName = v.name;

                    if (v && v.deptId) this.item.deptId = v.deptId;
                    //如果归属部门为绩效可发放部门，则绩效发放部门不开更改
                    if (v && v.deptId) {
                      this.item.scoreDeptId = v.deptId;
                      const foundItem = this.deptItems.find(item => item.dbid === this.item.scoreDeptId);
                      if (foundItem) {
                        const isScoreDept = foundItem.isScoredept; // 取出 field 字段的值
                        if(isScoreDept) this.scoreDeptDisnable = true
                        else this.scoreDeptDisnable = false
                      }
                    }

                    this.item.leaderPhone = v.phone;
                    this.item.leaderEmail = v.email;
                }
            },

          value(newVal) {
            if (newVal) {
              this.$nextTick(() => {
                this.$set(this.item, 'countFund', "T");
                this.$set(this.item, 'adminDeptId', "GIrgDQyAAAA");
                this.$refs.inputProjName.focus();
              });
            }
          },

        userId(newVal) {
          if (newVal) {
            this.leader = { userId: newVal }
          }
        },

        /*'item.scoreDeptId'(newVal){
          window.console.log("9999")
          if (newVal) {
            const foundItem = this.deptItems.find(item => item.dbid === newVal);
            if (foundItem) {
              const isScoreDept = foundItem.isScoredept; // 取出 field 字段的值
              if(isScoreDept) this.scoreDeptDisnable = true
              else this.scoreDeptDisnable = false
            }
          }
        }*/

        },

      methods: {
        handleUpdate(info) {
              this.item.leaderPhone = info.phone;
              this.item.leaderEmail = info.email;
              this.item.leaderId = info.userId;
              this.item.leaderName = info.name;
              this.item.deptId = info.deptId;
            },

            afterGetData(d) {
                this.leader = {
                    "userId": d.leaderId,
                    "name": d.leaderName,
                    "phone": d.leaderPhone,
                    "email": d.leaderEmail
                }
            },

            // 服务的国民经行业
            onIndstClsSearch() {
                const vm = this;
                const param = window.xutil.param("name", this.sectionSearch);
                param["sort"] = "rank.asc";

                vm.indstTypeLoading = true;
                this.axios.get('/api/proj/industry-type', {params: param})
                    .then(
                        rsp => {
                            vm.indstTypeLoading = false;
                            vm.indstTypeItems = rsp.data.items
                        })
            },

            async onCheck() {
              window.console.log("重复判断！")
              window.console.log(this.dbid)
                //如果新登记项目，则进行查重判断后再进行保存，否则直接保存
                if (!this.dbid || this.dbid.length === 0) {
                //采取异步方式判断项目是否重复，必需等待判断结果
                   await this.onCheckProjHave()
                   if (!this.projHave)
                   {
                      this.onSave()
                   }
                   }
                   else
                   {
                      this.onSave()
                   }
            },

            async onCheckProjHave() {
              const vm = this
              await axios.get(checkProjHaveUri,{
                params: {
                  name: vm.item.name.replace(/\s+/g, '').toLowerCase(),
                  typeId: vm.item.typeId
                }
              })
                  .then(rsp => {
                    if (rsp.data.found === "false") {
                      vm.projHave = false
                    }
                    else
                    {
                      vm.projName = vm.item.name
                      vm.projLeader = rsp.data.proj.leaderName
                      vm.projType = rsp.data.typ.name
                      vm.leaderDept = rsp.data.dept.name
                      vm.showAlert = true
                      vm.projHave = true
                    }
                  })
            }
        }
    }
</script>
<style>
.modern-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.modern-header {
  background: linear-gradient(135deg, #4a6baf 0%, #2c3e50 100%);
  color: white;
  padding: 13px 24px;
  text-align: center;
}

.modern-title {
  font-weight: 500;
  margin-top: 8px;
  letter-spacing: 0.5px;
}

.modern-content {
  padding: 24px;
  background-color: #f9fafc;
}

.modern-message {
  max-width: 90%;
  margin: 0 auto;
}

.modern-text {
  color: #5a6a85;
  margin-bottom: 12px;
  font-size: 1rem;
}

.modern-highlight {
  background-color: #f0f4ff;
  border-left: 3px solid #4a6baf;
  padding: 12px 16px;
  margin: 16px 0;
  border-radius: 0 4px 4px 0;
}

.modern-paper-title {
  color: #2c3e50;
  font-weight: 500;
  margin: 0;
  line-height: 1.5;
}

.modern-authors {
  background-color: #f5f7fa;
  padding: 12px 16px;
  border-radius: 4px;
  color: #4a5568;
  font-size: 1rem;
}

.modern-alert {
  display: flex;
  align-items: center;
  color: #e53e3e;
  font-weight: 500;
  gap: 8px;
}

.modern-actions {
  padding: 16px 24px;
  background-color: #f0f4ff;
}


.modern-btn {
  min-width: 100px;
  text-transform: none;
  letter-spacing: 0.5px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s;
}

.modern-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(74, 107, 175, 0.2);
}

/* 对话框整体样式 */
.professional-dialog {
  border-radius: 8px !important;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
}

/* 标题栏样式 */
.dialog-header {
  background: linear-gradient(135deg, #00b4db 0%, #0083b0 100%);
  padding: 4px 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}

.divider-gradient {
  height: 2px;
  background: linear-gradient(90deg, rgba(66,165,245,1) 0%, rgba(66,165,245,0.5) 50%, rgba(66,165,245,0) 100%);
}

/* 内容区域样式 max-height调整窗口高度*/
.dialog-content {
  padding: 24px;
  background-color: #fafafa;
  min-height: 200px;
  max-height: 90vh;
  overflow-y: auto;
}

.glassmorphism {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  padding: 12px 24px !important;
}

/* 现代按钮样式 */
.action-btn {
  border-radius: 8px !important;
  height: 42px;
  padding: 0 20px;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  text-transform: none;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

/* 主按钮悬浮效果 */
.action-btn.v-btn--contained:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2) !important;
}
</style>
